
























import PartnerReportDetailV2 from "@/components/partner/report/v2/PartnerReportDetail.vue";
import { PageFilterOperationEnum } from "@/lib/utility/data/page-filter-operation.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { PageFilterElement } from "@/models/page-filter-element.entity";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { ActivityLogModule } from "@/store/modules/activity-log.store";
import { ExportModule } from "@/store/modules/export.store";
import { FeatureModule } from "@/store/modules/feature.store";
import { UserModule } from "@/store/modules/me-user.store";
import { PartnerModule } from "@/store/modules/partner";
import { RefsMessagesModule } from "@/store/modules/refs.store";
import { ThirdPartySystemModule } from "@/store/modules/third-party-system.store";
import { Component, Prop, Vue } from "vue-property-decorator";
import SideCard from "../utility/SideCard.vue";
import PartnerReportDetail from "./PartnerReportDetail.vue";
import { IReport } from "@/models/report.entity";
import { handleError } from "@/lib/utility/handleError";

@Component({
  components: {
    SideCard,
    PartnerReportDetail,
    PartnerReportDetailV2
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class PartnerReportDetailSideCard extends Vue {
  @Prop({ default: false })
  loading!: boolean;

  mounting = true;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  get isReportV2() {
    return FeatureModule.isReportV2 || PartnerModule.partner.partnerType === PartnerTypeEnum.BROKER;
  }

  @Prop()
  value?: IReport;

  get report() {
    return PartnerModule.report;
  }

  beforeMount() {
    if (!this.value) {
      PartnerModule.setReport(this.report);
    }
  }

  async mounted() {
    this.mounting = true;

    if (this.value) {
      await this.value?.fetch().catch(handleError);
      PartnerModule.setReport(this.value);
    }

    if (
      FeatureModule.isTpsActive &&
      UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TPS, this.report.partnerId)
    ) {
      ThirdPartySystemModule.setFilters([
        new PageFilterElement({
          key: "refs.refId",
          operation: PageFilterOperationEnum.EQUAL,
          value: this.report._id
        })
      ]);
      await ThirdPartySystemModule.fetchFirstPage({ partnerId: this.report.partnerId }).catch(error =>
        this.$log.error(error)
      );
    } else {
      await ExportModule.getExportReportMetaByPartnerIdAndReportId({
        partnerId: this.report.partnerId,
        reportId: this.report._id
      }).catch(error => this.$log.error(error));
    }

    try {
      ActivityLogModule.setFilters([
        new PageFilterElement({
          key: "source.refId",
          operation: "$eq",
          value: this.report._id
        }),
        new PageFilterElement({
          key: "source.refType",
          operation: "$eq",
          value: BackendResourceEnum.REPORT
        })
      ]);

      await ActivityLogModule.fetchFirstPage({
        partnerId: this.report.partnerId
      });

      if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.VEHICLE, this.report.partnerId)) {
        if (this.report) {
          await this.report.fetchVehicle();

          if (UserModule.abilities.can(ActionEnum.READ, ResourceEnum.FLEET, this.report.partnerId)) {
            if (this.report.vehicle) {
              await this.report.vehicle?.fetchFleet();
            }
          }
        }
      }
    } catch (error) {
      this.$log.error(error);
    } finally {
      this.loading = false;
    }

    RefsMessagesModule.generateFrontendTimeLineElementsForMessagesAssociatedWithReference({
      refId: this.report.id,
      partnerId: this.report.partnerId
    });

    this.mounting = false;
  }
}
